import { render, staticRenderFns } from "./ActivityManagement.vue?vue&type=template&id=2b5e9510&scoped=true&"
import script from "./ActivityManagement.vue?vue&type=script&lang=ts&"
export * from "./ActivityManagement.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityManagement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ActivityManagement.vue?vue&type=style&index=1&id=2b5e9510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e9510",
  null
  
)

export default component.exports